import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import findIndex from 'lodash/findIndex'
// import sumBy from 'lodash/sumBy'
// import $ from 'jquery'
// import Modal from 'react-responsive-modal'
import Select from 'react-select'
import UserActions from '../../Redux/UserRedux'

class Count extends React.Component {
  constructor (props) {
    super (props)
    let monthList = []
    let yearList = []
    moment.months().map( (label, i) => monthList.push({ value: i, label }) )

    for (let index = 2018; index <= moment().year(); index++) {
      yearList.push({ value: index, label: index })
      // this would add years, starting from 2018
    }

    this.month = monthList
    this.year = yearList
    this.state = {
      showModal: null,
      month: this.month[moment().month()],
      year: this.year[ findIndex(this.year, (list) => list.value === moment().year()) ]
    }
  }

  componentDidMount = () => {
    this._fetchUserCount({})
  }

  _fetchUserCount = ({ month= this.state.month.value, year= this.state.year.value }) => {
    const monthYear = moment().set({ year, month })
    const firstDate = monthYear.startOf('month').format('Y-MM-DD')
    const lastDate = monthYear.endOf('month').format('Y-MM-DD')

    const filter = {
      from: firstDate,
      until: lastDate
    }

    this.props.getUserCount(filter)
  }

  _dateChange = (value, field) => {
    let newState = {...this.state}
    newState[field] = value
    this.setState(newState)
    let date = {
      month: this.state.month.value,
      year: this.state.year.value
    }
    date[field] = value.value
    this._fetchUserCount(date)
  }

  render() {
    const { user_count, user } = this.props

    const monthYear = moment().set({ year: this.state.year.value, month: this.state.month.value })
    const lastDate = monthYear.endOf('month').date()

    let dates = []
    for (let index = 0; index < lastDate; index++) {
      dates.push(index)
    }

    let userTotal = 0
    user_count.map((item, i) => userTotal += item.count)

    return (
      <div>
        <header className="section">
          <div className="title-block d-flex mb-3 justify-content-between">
            <h3 className="title mr-auto">
              User Count
              {(user.fetching || user.processing) && 
                <div className="badge badge-info ml-2">{user.fetching ? 'Loading' : 'Processing'} ...</div> 
              }
            </h3>
          </div>
          <div className="title-block">
            {/* <p className="title-description">Filter:</p> */}
            <div className="form-inline">
              <div className="form-group mr-2">
                <label className="control-label mr-2">Month</label>
                <div style={{ minWidth: '120px' }}>
                  <Select options={this.month} value={this.state.month} onChange={(value) => this._dateChange(value, 'month')}/>
                </div>
              </div>
              <div className="form-group mr-2">
                <label className="control-label mr-2">Year</label>
                <div style={{ minWidth: '120px' }}>
                  <Select options={this.year} value={this.state.year} onChange={(value) => this._dateChange(value, 'year')}/>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section className="section" style={{ width: '50%' }}>
          <div className="card">
            {!(user.fetching || user.processing) && user.err &&
              <div className="alert alert-danger">{user.err}</div> 
            }
            <div className="card-block">
              <div className="title-block">
                <h5 className="title">
                  Total User : <strong>{ userTotal }</strong>
                </h5>
              </div>
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                    <th className="text-center">Date</th>
                    <th className="text-center">User Count</th>
                  </tr>
                </thead>
                <tbody>
                    {dates.map((i) => {
                      const date = moment().set({ year: this.state.year.value, month: this.state.month.value, date: i+1 })
                      const exist = findIndex(user_count, (data) => data.date === date.format('Y-MM-DD'))
                      let count = 0
                      if (exist >= 0) {
                        count = user_count[exist].count
                      }
                      return (
                        <tr key={i}>
                          <td className="text-center">{i + 1}</td>
                          <td className="text-center" style={{ verticalAlign: 'middle' }}>{ count }</td>
                        </tr>
                      )
                      })
                    }
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  user_count: state.user.user_count,
  user: state.user
})

const dispatchToProps = (dispatch) => ({
  getUserCount: (filter) => dispatch(UserActions.userCountRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(Count)



// WEBPACK FOOTER //
// ./src/Pages/User/Count.js